import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useDispatch } from "react-redux";
import { Control } from "../../control/control";
import { ControlGroup } from "../../controlGroup/controlGroup";
import { Text } from "../../text/text";
import { resetAttachTo, setAttachTo } from "../../../features/config/config.slice";
export const GeneralSettings = ({ attachTo }) => {
    const dispatch = useDispatch();
    return (_jsxs(_Fragment, { children: [_jsx("h2", { children: "Snowfall settings" }), _jsxs("p", { children: ["Everything below here (except for Layer Titles) ", _jsx("b", { children: "will" }), " be exported with your config."] }), _jsx(ControlGroup, { children: _jsx(Control, { name: "Attach to", tooltip: "The element to attach the snowfall simulation to", reset: () => {
                        dispatch(resetAttachTo());
                    }, value: attachTo, onChange: (event) => dispatch(setAttachTo(event.target.value)), children: _jsx(Text, {}) }) })] }));
};
